module.exports = __webpack_public_path__ + "ada8cc910e36936baa2b472a187fd3f4.pdf";